document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.scrollTop = 0;
    // if ('serviceWorker' in navigator) {
    //     navigator.serviceWorker.register('/static/public/sw.js')
    // }
});
